<assessment-row title="Extremity Movement">
  <p>{{ data.extremityMovement }}</p>
</assessment-row>

<assessment-row title="Hand Grips">
  <p>{{ data.handGrips }}</p>
</assessment-row>
<assessment-row title="LE Push/Pull">
  <p>{{ data.lePushPull }}</p>
</assessment-row>

<assessment-row title="Glasgow Coma Scale Score">
  <p>{{ data.gcss }}</p>
</assessment-row>

<h2>Sensation</h2>
<assessment-row title="RUE">
  <p>{{ data.sensationRue }}</p>
</assessment-row>
<assessment-row title="RLE">
  <p>{{ data.sensationRle }}</p>
</assessment-row>
<assessment-row title="LLE">
  <p>{{ data.sensationLle }}</p>
</assessment-row>
<assessment-row title="LUE">
  <p>{{ data.sensationLue }}</p>
</assessment-row>

<assessment-row title="Tremors">
  <emr-list [list]="data.tremors" emptyText="None"></emr-list>
</assessment-row>

@if (patient().isObstetric()) {
@if (data.isEpidural) {
<h2>Epidural</h2>
<assessment-row title="Level of Sensory Block">
  <p>{{ data.sensoryBlockLevel }}</p>
</assessment-row>
}

<assessment-row title="Abnormal Reflexes Noted">
  <p>{{ data.abnormalReflexesNoted }}</p>
</assessment-row>
}